import Button from '@/components/button';
import { Box, useMediaQuery } from '@mui/material';

import { Modal } from '@mui/material';
import { useState } from 'react';
import CookieContent from './content';
import { useDispatch } from 'react-redux';
import { setCookieConfig } from '@/redux/cookieSlice';
import { IoClose } from 'react-icons/io5';
import { Brand } from '@/components/brand/icons/brand';
import CookieMobileContent from './mobileContent';

export function CookieContentModal() {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const style = {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'rgba(7, 10, 20, 1)'
  };
  const isMobile = useMediaQuery('(max-width:1280px)'); // 使用 MUI 的 useMediaQuery

  const component = isMobile ? <CookieMobileContent /> : <CookieContent />;
  return (
    <>
      <Button
        className="mx-4 flex h-[50px] w-full items-center justify-center"
        onClick={() => {
          handleOpen();
        }}
      >
        Customise
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        hideBackdrop
      >
        <Box
          sx={style}
          className="absolute h-screen w-full overflow-auto border-none lg:h-[524px] lg:w-[730px] lg:rounded-2xl lg:border lg:border-solid lg:border-[#3830D4]"
        >
          <div className="relative flex items-center gap-2 border-b border-[#3C2B68] px-4 py-2">
            <Brand className="w-9 max-md:w-4" />
            <h2 className="text-xl lg:text-2xl">Privacy Preference Center</h2>
            <IoClose
              className="absolute right-4 top-4  cursor-pointer text-2xl"
              onClick={handleClose}
            />
          </div>
          {component}
          <div className="flex flex-col items-center justify-center bg-[#081029] p-8 lg:items-end lg:p-0 lg:pr-8">
            <Button
              className="flex h-[50px] w-[300px] items-center justify-center lg:w-[220px]"
              style={{
                backgroundImage:
                  'linear-gradient(90deg, #280580 0%, #7808ED 100%)'
              }}
              onClick={() => dispatch(setCookieConfig('' as any))}
            >
              Confirm My Choices
            </Button>
            <Button
              className="mt-2 flex h-[50px] w-[300px] items-center justify-center lg:hidden lg:w-[220px]"
              variant="outline"
              onClick={() => dispatch(setCookieConfig('' as any))}
            >
              Reject All
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
